import { jsx as _ } from "react/jsx-runtime";
import { a as x } from "../../core-DVmjA3_O.js";
import { _ as f } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import '../../index22.css';const m = "_description_icffo_1", d = "_with-centered-content_icffo_9", S = "_text-size-extra-small_icffo_15", V = "_text-size-small_icffo_19", h = "_text-size-medium_icffo_23", z = "_text-size-large_icffo_27", g = "_color-variant-text_icffo_31", p = "_color-variant-text-on-dark_icffo_35", u = "_color-variant-primary_icffo_39", y = "_color-variant-secondary_icffo_43", T = "_color-variant-success_icffo_47", w = "_color-variant-danger_icffo_51", C = "_with-light-text_icffo_55", t = {
  description: m,
  withCenteredContent: d,
  textSizeExtraSmall: S,
  textSizeSmall: V,
  textSizeMedium: h,
  textSizeLarge: z,
  colorVariantText: g,
  colorVariantTextOnDark: p,
  colorVariantPrimary: u,
  colorVariantSecondary: y,
  colorVariantSuccess: T,
  colorVariantDanger: w,
  withLightText: C
}, D = {
  text: t.colorVariantText,
  primary: t.colorVariantPrimary,
  secondary: t.colorVariantSecondary,
  success: t.colorVariantSuccess,
  danger: t.colorVariantDanger,
  "text-on-dark": t.colorVariantTextOnDark
};
function E(r) {
  const {
    className: a,
    children: i,
    withCenteredContent: n,
    elementRef: c,
    textSize: e = "md",
    withLightText: s,
    colorVariant: o,
    ...l
  } = r;
  return /* @__PURE__ */ _(
    "div",
    {
      ...l,
      ref: c,
      className: f(
        t.description,
        n && t.withCenteredContent,
        e === "xs" && t.textSizeExtraSmall,
        e === "sm" && t.textSizeSmall,
        e === "md" && t.textSizeMedium,
        e === "lg" && t.textSizeLarge,
        x(o) && D[o],
        s && t.withLightText,
        a
      ),
      children: i
    }
  );
}
export {
  E as default
};
